import { CardSection } from "./common/Card";
import { useState } from "react";
import { Alert } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { TypedDateRangePicker } from "./common/DateRangePicker";
import {DownloadCSVButton} from "./common/SubmitButton";
import { DateTime } from "../time/DateTime";
import { Result } from "../client/Result";
import {MeterApi} from "../client/MeterClient";
import { MpanInput } from "./BuildingInput";
import {Select, SelectOption} from "./common/MuiSelect";


interface MeterDataProps {
    meters: MeterApi[]
    download: (mpan: string, start: string, end: string, format?: string) => Promise<Result<void>>
    header: string
    className?: string
    'data-testid'?: string
    formatOptions?: SelectOption[]
}

export const MeterData = ({meters, download, className, header, 'data-testid': dataTestId, formatOptions}: MeterDataProps) => {
    const [mpan, setMpan] = useState<string>()
    const [startDate, setStartDate] = useState<DateTime>()
    const [endDate, setEndDate] = useState<DateTime>()
    const [dateRangeValid, setDateRangeValid] = useState(false)

    const [validated, setValidated] = useState(false);

    const [errorMessage, setErrorMessage] = useState<string>()
    const [format, setFormat] = useState<string>()

    async function handleSubmit(event) {
        const form = event.currentTarget
        setErrorMessage(undefined)
        event.preventDefault()
        setValidated(true)
        if (form.checkValidity() === true && dateRangeValid && startDate && endDate) {
            const submissionResult = await download(mpan!, startDate.toISODate(), endDate.toISODate(), format)
            submissionResult.fold(
                () => undefined,
                err => setErrorMessage(`An error occurred - #ask-tech for support. ${err}`)
            )
        } else {
            form.reportValidity()
        }
    }

    const onChange = (e: MeterApi) => {
        setErrorMessage(undefined)
        setMpan(e.mpan)
    };

    function handleFormatChange(e: SelectOption) {
        setFormat(e.id)
    }

    return <CardSection className={className} header={header} as="h6">
        <Form noValidate validated={validated}>
            <MpanInput meters={meters} meter={meters.find(it => it.mpan === mpan)} testId={dataTestId}
                       onBuildingChange={onChange} className={'mb-3'} disabled={false}/>
            <TypedDateRangePicker start={startDate} end={endDate} onEndChange={setEndDate} onStartChange={setStartDate}
                                  setErrorMessage={setErrorMessage} reportIsValid={setDateRangeValid}
                                  testId={dataTestId}/>
            {formatOptions && <Select options={formatOptions} label={"Format"} onChange={handleFormatChange} className={'mb-3'} data-testid={dataTestId ? `${dataTestId}_meterDataFormatSelect` : 'meterDataFormatSelect'}/>}

            <DownloadCSVButton dataTestId={dataTestId ? `${dataTestId}_meterDataSubmitButton` : 'meterDataSubmitButton'}
                               disabled={!(mpan && startDate && endDate && (startDate.toMillis() <= endDate.toMillis()) && (!formatOptions || format)) }
                               onSubmit={handleSubmit}/>
            {errorMessage &&
                <Alert data-testid='errorMessage' variant='danger'>{errorMessage}</Alert>}
        </Form>
    </CardSection>
}
